export default function BakimPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center px-4">
      <div className="text-center max-w-lg">
        <div className="w-24 h-24 bg-orange-500/20 border-2 border-orange-500/40 rounded-full flex items-center justify-center mx-auto mb-8 animate-pulse">
          <i className="ri-tools-line text-orange-400 text-5xl"></i>
        </div>
        <h1 className="text-4xl font-bold text-white mb-4">Bakım Çalışması</h1>
        <p className="text-gray-400 text-lg mb-8 leading-relaxed">
          Sitemiz şu anda bakım çalışması nedeniyle geçici olarak kapalıdır.
          En kısa sürede tekrar hizmetinizde olacağız.
        </p>
        <div className="flex items-center justify-center gap-3 bg-white/5 border border-white/10 rounded-xl px-6 py-4">
          <i className="ri-time-line text-orange-400 text-xl"></i>
          <span className="text-gray-300 text-sm">Çok yakında geri döneceğiz...</span>
        </div>
      </div>
    </div>
  );
}
